var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","position":"relative"}},[_c('div',{attrs:{"id":"allpay"}}),_vm._v(" "),_c('div',{attrs:{"id":"hejizhichu"}},[_c('span',{staticStyle:{"font-size":"20px","color":"#50c8ff"}},[_vm._v(_vm._s(this.utils.formatMoney(_vm.allMoney)))]),_vm._v(" "),_c('p',[_vm._v("合计支出(￥)")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d66d1170","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/tangci/xunchache.vue
// module id = null
// module chunks = 